import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Redux Saga
import {
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAIL,
  GET_ORDER_SUCCESS,
  GET_ORDER_FAIL,
  UPDATE_ORDER_STATUS_SUCCESS,
  UPDATE_ORDER_STATUS_FAIL,
  ORDER_CONFIRMATION_SUCCESS,
  ORDER_CONFIRMATION_FAIL,
} from "./actionTypes"

// Orders actions
import {
  getOrders as getOrdersAction,
  getOrder as getOrderAction,
} from "./actions"

// API functions
import {
  getOrders,
  getOrderById,
  updateOrderStatus,
  orderConfirmation,
} from "../../helpers/backend_helper"

// Toast for notifications
import { toast } from "react-toastify"

// Get all orders
function* fetchOrders({ payload: { params, history } }) {
  try {
    const response = yield call(getOrders, params)
    yield put({ type: GET_ORDERS_SUCCESS, payload: response })
  } catch (error) {
    yield put({ type: GET_ORDERS_FAIL, payload: error })
    toast.error("Failed to load orders")
  }
}

// Get single order
function* fetchOrder({ payload: { orderId, history } }) {
  try {
    const response = yield call(getOrderById, orderId)
    yield put({ type: GET_ORDER_SUCCESS, payload: response })
  } catch (error) {
    yield put({ type: GET_ORDER_FAIL, payload: error })
    toast.error("Failed to load order details")
  }
}

// Update order status
function* onUpdateOrderStatus({ payload: { orderId, statusData, history } }) {
  try {
    yield call(updateOrderStatus, orderId, statusData)
    // Fetch the updated order by ID
    const updatedOrder = yield call(getOrderById, orderId)
    yield put({ type: UPDATE_ORDER_STATUS_SUCCESS, payload: updatedOrder })
    toast.success("Order status updated successfully!")
  } catch (error) {
    yield put({ type: UPDATE_ORDER_STATUS_FAIL, payload: error })
    toast.error("Failed to update order status")
  }
}

// Order confirmation
function* onOrderConfirmation({ payload: { orderId, confirmationData, history } }) {
  try {
    yield call(orderConfirmation, orderId, confirmationData)
    // Fetch the updated order by ID
    const confirmedOrder = yield call(getOrderById, orderId)
    yield put({ type: ORDER_CONFIRMATION_SUCCESS, payload: confirmedOrder })
    toast.success("Order confirmed successfully!")
  } catch (error) {
    yield put({ type: ORDER_CONFIRMATION_FAIL, payload: error })
    toast.error("Failed to confirm order")
  }
}

// Watchers
function* getOrdersSaga() {
  yield takeEvery("GET_ORDERS", fetchOrders)
}

function* getOrderSaga() {
  yield takeEvery("GET_ORDER", fetchOrder)
}

function* updateOrderStatusSaga() {
  yield takeEvery("UPDATE_ORDER_STATUS", onUpdateOrderStatus)
}

function* orderConfirmationSaga() {
  yield takeEvery("ORDER_CONFIRMATION", onOrderConfirmation)
}

// Export all sagas
function* ordersSaga() {
  yield all([
    fork(getOrdersSaga),
    fork(getOrderSaga),
    fork(updateOrderStatusSaga),
    fork(orderConfirmationSaga),
  ])
}

export default ordersSaga
